import { render, staticRenderFns } from "./PrivilegeDropdown.vue?vue&type=template&id=5bf40721"
import script from "./PrivilegeDropdown.vue?vue&type=script&lang=js"
export * from "./PrivilegeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports